import { render } from "./MyCheckbox.vue?vue&type=template&id=1023e4a6"
import script from "./MyCheckbox.vue?vue&type=script&lang=js"
export * from "./MyCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "C:\\www\\webdesign - zelena\\vue\\dotacezelena-cz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__